import React, { ReactNode, useRef } from 'react'
import { Provider } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { Store } from 'redux'
import configureStore from '../../store'

interface Props {
  children?: ReactNode
}

const ProviderWithRouter: React.FC<Props> = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()

  // Keep refs so the saga context always calls the latest navigate/location
  const navigateRef = useRef(navigate)
  navigateRef.current = navigate
  const locationRef = useRef(location)
  locationRef.current = location

  const storeRef = useRef<Store<any, any> | null>(null)
  if (!storeRef.current) {
    const routerHistory = {
      push: (path: string, state?: any) => navigateRef.current(path, { state }),
      replace: (path: string, state?: any) => navigateRef.current(path, { replace: true, state }),
      goBack: () => navigateRef.current(-1),
      get location() {
        return locationRef.current as any
      }
    }
    storeRef.current = configureStore({}, { routerHistory })
  }

  return (
    <Provider store={ storeRef.current! }>
      { children }
    </Provider>
  )
}

export default ProviderWithRouter
